import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { VISIBLE_ADDRESS_COLS_INITIAL_STATE } from '../../constants/addressBook';
import { VISIBLE_INVENTORY_COLS_INITIAL_STATE } from '../../constants/inventories';
import { VISIBLE_ONE_LINKS_COLS_INITIAL_STATE } from '../../constants/oneLink';
import { VISIBLE_REPORTS_COLS_INITIAL_STATE } from '../../constants/reports';
import { IReduxAction } from '../../types/redux';
import { IEngagementOrderIdResponseActionPayload, IToolsState } from '../../types/tools';
import * as AuthActions from '../actions/auth';
import * as ToolsActions from '../actions/tools';

export const initialState: IToolsState = {
  engagement: null,
  visibleReportsColumns: VISIBLE_REPORTS_COLS_INITIAL_STATE,
  visibleOneLinksColumns: VISIBLE_ONE_LINKS_COLS_INITIAL_STATE,
  visibleInventoryColumns: VISIBLE_INVENTORY_COLS_INITIAL_STATE,
  visibleAddressColumns: VISIBLE_ADDRESS_COLS_INITIAL_STATE,
  isLoading: false,
  error: null,
};

const reducer = (state: IToolsState = initialState, action: any): IToolsState => {
  switch (action.type) {
    case ToolsActions.FETCH_ENGAGEMENT_BY_ORDER_ID_REQUEST: {
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    }
    case ToolsActions.FETCH_ENGAGEMENT_BY_ORDER_ID_SUCCESS: {
      const { engagement = null } = (action as IReduxAction<IEngagementOrderIdResponseActionPayload>).payload || {};

      return {
        ...state,
        engagement,
        isLoading: false,
      };
    }
    case ToolsActions.FETCH_ENGAGEMENT_BY_ORDER_ID_FAILURE: {
      return {
        ...state,
        engagement: null,
        error: action.payload,
        isLoading: false,
      };
    }
    case ToolsActions.DELETE_ENGAGEMENT_BY_ORDER_ID_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ToolsActions.DELETE_ENGAGEMENT_BY_ORDER_ID_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        engagement: null,
      };
    }
    case ToolsActions.DELETE_ENGAGEMENT_BY_ORDER_ID_FAILURE: {
      return {
        ...state,
        isLoading: false,
        engagement: null,
        error: action.payload,
      };
    }
    case ToolsActions.CANCEL_ENGAGEMENT_BY_ORDER_ID_REQUEST: {
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    }
    case ToolsActions.CANCEL_ENGAGEMENT_BY_ORDER_ID_SUCCESS: {
      return {
        ...state,
        engagement: null,
        isLoading: false,
      };
    }
    case ToolsActions.CANCEL_ENGAGEMENT_BY_ORDER_ID_FAILURE: {
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    }
    case ToolsActions.CLEAR_ENGAGEMENT: {
      return {
        ...state,
        engagement: null,
        error: null,
      };
    }
    case FirebaseActions.LOGOUT:
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS: {
      return initialState;
    }
    case ToolsActions.CHANGE_REPORTS_COLUMNS_VISIBILITY: {
      return {
        ...state,
        visibleReportsColumns: {
          ...action.payload,
        },
      };
    }
    case ToolsActions.CHANGE_ONE_LINKS_COLUMNS_VISIBILITY: {
      return {
        ...state,
        visibleOneLinksColumns: {
          ...action.payload,
        },
      };
    }
    case ToolsActions.CHANGE_INVENTORY_COLUMNS_VISIBILITY: {
      return {
        ...state,
        visibleInventoryColumns: {
          ...action.payload,
        },
      };
    }
    case ToolsActions.CHANGE_ADDRESS_COLUMNS_VISIBILITY: {
      return {
        ...state,
        visibleAddressColumns: {
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
